import React from "react";
import { motion } from "framer-motion"; // Importing framer-motion for scroll animations
import "../../assets/styles/brands.css";
import { FaGlobe } from "react-icons/fa"; 
import Brand1 from "../../assets/images/brand1.jpg";
import Brand2 from "../../assets/images/brand2.jpg";
import Brand3 from "../../assets/images/brand3.jpg";
import Brand4 from "../../assets/images/brand44.jpg";

const Brand = ({ title, subtitle, stats }) => {

  const handleImageClick = (url) => {
    window.open(url, "_blank"); 
  };

  return (
    <div className="brands-section">
      <div className="brands-background"></div>
      {/* Animated Header Section */}
      <header className="text-center py-5">
        <motion.h1
          className="title"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }} // Trigger animation when 30% is in view
          transition={{ duration: 1.5, ease: "easeInOut" }}
        >
          BRANDS
        </motion.h1>
        <br />

        {/* Container for Paragraph and Image with Same Width */}
        <div
          className="content-container"
          style={{ width: "80%", margin: "0 auto" }}
        >
          {/* Animated Paragraph */}
          <motion.p
            className="newsubtitle"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
          >
            Leading Brands, Limitless Possibilities.
            </motion.p>
          <motion.p
            className="subtitle"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
          >
            As a premier provider of
            tech-enabled solutions, commceed combines industry-leading
            expertise with seamless, end-to-end support. From design to
            deployment, our vast portfolio of top-tier brands ensures we offer
            the best products and services to suit your needs. New brands are
            continuously being added to our selection. Check back for the latest
            updates.
          </motion.p>

          {/* Animated Image */}
          <div className="brand-images-grid">
      <motion.div className="brand-image-container">
        <motion.img
          src={Brand1}
          alt="Brand 1"
          className="brand-image"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          // onClick={() => handleImageClick("https://www.commscope.com/systimax/")}
        />
        <motion.button
          className="visit-button"
          onClick={() => handleImageClick("https://www.commscope.com/systimax/")}
        >
          <FaGlobe style={{ marginRight: "8px" }} /> {/* Adding the globe icon */}
          Visit
        </motion.button>
      </motion.div>

      <motion.div className="brand-image-container">
        <motion.img
          src={Brand2}
          alt="Brand 2"
          className="brand-image"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut", delay: 0.1 }}
          // onClick={() => handleImageClick("https://www.commscope.com/product-type/networking-systems/structured-cabling/netconnect/")}
        />
        <motion.button
          className="visit-button"
          onClick={() => handleImageClick("https://www.commscope.com/product-type/networking-systems/structured-cabling/netconnect/")}
        >
          <FaGlobe style={{ marginRight: "8px" }} /> {/* Adding the globe icon */}
          Visit
        </motion.button>
      </motion.div>

      <motion.div className="brand-image-container">
        <motion.img
          src={Brand3}
          alt="Brand 3"
          className="brand-image"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut", delay: 0.2 }}
          // onClick={() => handleImageClick("https://www.commscope.com/product-type/cables/fiber-cables/")}
        />
        <motion.button
          className="visit-button"
          onClick={() => handleImageClick("https://www.commscope.com/product-type/cables/fiber-cables/")}
        >
          <FaGlobe style={{ marginRight: "8px" }} /> {/* Adding the globe icon */}
          Visit
        </motion.button>
      </motion.div>

      <motion.div className="brand-image-container">
        <motion.img
          src={Brand4}
          alt="Brand 4"
          className="brand-image"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut", delay: 0.3 }}
          // onClick={() => handleImageClick("https://www.chatsworth.com/en-us/products/racks-cable-management/two-post-racks")}
        />
        <motion.button
          className="visit-button"
          onClick={() => handleImageClick("https://www.chatsworth.com/en-us/products/racks-cable-management/two-post-racks")}
        >
          <FaGlobe style={{ marginRight: "8px" }} /> {/* Adding the globe icon */}
          Visit
        </motion.button>
      </motion.div>
    </div>

        </div>
      </header>
    </div>
  );
};

export default Brand;
